/// <amd-module name="Artifacts/Nuget/commands/Unlist" />

import { NugetActions } from "Artifacts/Nuget/redux";
import { getUnlistCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createListStatusCommand = getUnlistCommandCreator(NugetActions.changeListStatus);
